import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { timerPillRootSx, timerPillTextSx } from "./styles";

const pad2 = (n: number) => String(Math.max(0, Math.floor(n))).padStart(2, "0");

const formatMmSs = (seconds: number): string => {
  const s = Math.max(0, Math.floor(seconds));
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  return `${pad2(mm)}:${pad2(ss)}`;
};

interface StageTimerPillProps {
  remainingSeconds: number | null | undefined;
}

export const StageTimerPill: React.FC<StageTimerPillProps> = ({
  remainingSeconds,
}) => {
  const text = useMemo(() => {
    if (typeof remainingSeconds !== "number" || !isFinite(remainingSeconds)) {
      return "--:--";
    }
    return formatMmSs(remainingSeconds);
  }, [remainingSeconds]);

  return (
    <Box sx={timerPillRootSx}>
      <Typography sx={timerPillTextSx}>
        TIMER:{" "}
        <span style={{ fontFamily: "monospace", letterSpacing: 1.2 }}>
          {text}
        </span>
      </Typography>
    </Box>
  );
};
